import React from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';
import { Logo } from '../../../ui/logo/office/Index';
import EmailNewIcon from '../../../ui/icons/EmailNewIcon';

interface IBroker {
  name: string;
  email?: string;
  phoneNumber?: string;
  officeName?: string;
  urltag?: string;
  titles?: string;
}

const Broker: React.FC<IBroker> = ({
  name,
  phoneNumber,
  officeName,
  urltag,
  titles
}) => {
  return (
    <StyledBrokerItem>
      {urltag ? (
        <Link to={urltag}>
          <Logo name={officeName} className="logo" alt="bilde av logo" />
        </Link>
      ) : (
        <Logo name={officeName} alt="bilde av logo" />
      )}
      <StyledBrokerItemContent>
        {name ? (
          urltag ? (
            <StyledBrokerNameLink className="name" to={urltag}>
              {name}
            </StyledBrokerNameLink>
          ) : (
            <StyledBrokerName className="name">{name}</StyledBrokerName>
          )
        ) : null}
        {titles ? <span className="title">{titles}</span> : null}
        <span className="contact-info">
          {phoneNumber ? (
            <span className="phone">
              <a href={`tel:${phoneNumber.replace(/ /g, '')}`}>{phoneNumber}</a>
            </span>
          ) : null}
          {urltag ? (
            <LinkContact
              className={!phoneNumber ? `first` : ``}
              href={`${urltag}/kontakt`}
            >
              <EmailNewIcon />
            </LinkContact>
          ) : null}
        </span>
      </StyledBrokerItemContent>
    </StyledBrokerItem>
  );
};

const LinkContact = styled.a`
  div {
    margin-top: 0;
  }
  &.first {
    div {
      padding-left: 0;
    }
  }
`;

const StyledBrokerItem = styled.div`
  display: flex;
  width: 100%;
  flex-flow: column;
  align-items: center;
  margin-bottom: 20px;
  float: left;
  text-decoration: none;
  font-weight: 300;

  &:last-child {
    margin-bottom: 0;
  }

  .logo {
    max-width: 180px;
    text {
      font-size: 105px;
    }
  }
`;

const StyledBrokerNameLink = styled(Link)`
  padding: 0.5rem 0 1rem 0;
  font-size: 1.1875rem;
  color: ${(props) => props.theme.colors.primary};
  text-decoration: none;
`;

const StyledBrokerName = styled.span`
  padding: 0.5rem 0 1rem 0;
  font-size: 1.1875rem;
  color: ${(props) => props.theme.colors.primary};
  text-decoration: none;
`;

const StyledBrokerItemContent = styled.div`
  display: flex;
  flex-flow: column;
  justify-content: center;
  padding: 0;
  text-align: center;

  span {
    &.title {
      font-size: 0.75rem;
      color: white;
    }
    &.office {
      margin-top: 10px;
      font-size: 0.75rem;
      color: white;
    }
    &.contact-info {
      display: flex;
      justify-content: center;
      padding: 1rem 0 0 0;
    }
    &.phone {
      float: left;
      a {
        text-decoration: none;
      }
    }
    &.email {
    }
  }
`;

export default Broker;
